export default {
      id: "city-icon-8-usage",
      viewBox: "0 0 95 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-8",
      toString: function () {
        return this.url;
      }
    }